import { ColumnSortType, TableColumnTypes } from '../../model/table.model';

export const tableHeaders = [
  {
    value: 'title',
    sort: ColumnSortType.NONE,
    name: 'Назва',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
  },
  {
    value: 'description',
    sort: ColumnSortType.NONE,
    name: 'Опис відправлення',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
  },
  {
    value: 'weight',
    sort: ColumnSortType.NONE,
    name: 'Вага',
    type: TableColumnTypes.NOVA_POSHTA_STATUS,
    className: 'table-header',
  },
  {
    value: 'place',
    sort: ColumnSortType.NONE,
    name: 'Місце',
    type: TableColumnTypes.DATE,
    className: 'table-header',
  },
  {
    value: 'action',
    sort: ColumnSortType.NONE,
    name: '',
    type: TableColumnTypes.ACTION,
    className: 'three-dot',
    actions:
      [
        { icon: 'delete', label: 'delete', value: 'DELETE' },
      ],
    translate: true,
  },
];
